/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - _app.js: main js file for the web app
 */

import { tns } from 'tiny-slider/src/tiny-slider';
import '../../../node_modules/tiny-slider/src/tiny-slider.scss';

export const promiseTimeout = 1000000;
export function ensureLarouteIsSet(promiseTimeout) {
    const start = Date.now();
    return new Promise(waitForLaroute);

    function waitForLaroute(resolve, reject) {
        if (LaravelRoutes.prototype.routes) { // eslint-disable-line no-undef
            resolve(LaravelRoutes.prototype.routes); // eslint-disable-line no-undef
        } else if (promiseTimeout && (Date.now() - start) >= promiseTimeout) {
            reject(new Error('timeout'));
        } else {
            setTimeout(waitForLaroute.bind(this, resolve, reject), 30);
        }
    }
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - js-news-item__slider init
 */
const newsItemSlider = document.querySelector('.js-news-item__slider');

if (newsItemSlider) {
    const newsSlider = tns({// eslint-disable-line no-unused-vars
        container: newsItemSlider,
        items: 1,
        speed: 500,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayButtonOutput: false,
        controls: false,
        nav: true,
        navPosition: 'bottom',
        gutter: 50
    });
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - js-news-item__slider init
 */
const productItemSlider = document.querySelector('.js-product-info__slider');

if (productItemSlider) {
    const productSlider = tns({// eslint-disable-line no-unused-vars
        container: productItemSlider,
        items: 1,
        speed: 500,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayButtonOutput: false,
        controls: false,
        nav: true,
        navPosition: 'bottom',
        gutter: 50
    });
}

/**
 * @author - Nikky Lauwers <n.lauwers@bluedragon.nl>
 * @description - Hamburger btn
 */
const toggleHamburgerBtn = document.querySelector('.js-header__hamburger');
const mobileMenuActiveClass = 'c-header__hamburger--active';
const mobileMenuBodyActiveClass = 'mobilemenu--active';

if (toggleHamburgerBtn) {
    toggleHamburgerBtn.addEventListener('click', () => {
        toggleHamburgerBtn.classList.toggle(mobileMenuActiveClass);
        documentBody.classList.toggle(mobileMenuBodyActiveClass);
    });
}

/**
 * @author - Nikky Lauwers <n.lauwers@bluedragon.nl>
 * @description - Close the hamburger menu and overlay
 */
function closeHamburgerMenu() {
    documentBody.classList.remove(mobileMenuBodyActiveClass);
    toggleHamburgerBtn.classList.remove(mobileMenuActiveClass);
}

/**
 * @author - Nikky Lauwers <n.lauwers@bluedragon.nl>
 * @description - Handle trigger overlay
 */
const btnOverlayClose = document.querySelector('.js-modal__overlay');

if (btnOverlayClose) {
    btnOverlayClose.addEventListener(('click'), closeHamburgerMenu);
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - Open the modal
 */
const documentBody = document.querySelector('body');
function openModal(modal) {
    document.querySelectorAll('[data-modal=' + modal + ']').forEach((openModal) => {
        openModal.classList.add('c-modal__open');
        const topPosition = (window.pageYOffset || document.documentElement.scrollTop) + 50;
        openModal.style.top = topPosition + 'px';
    });
    documentBody.classList.add('modal--open');
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - Close the modal
 */
function closeModal() {
    documentBody.classList.remove('modal--open');
    document.querySelectorAll('.c-modal').forEach((modal) => {
        modal.classList.remove('c-modal__open');
    });
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @author - Nikky Lauwers <n.lauwers@bluedragon.nl>
 * @description - Handle trigger modal open
 */
const btnModalOpen = document.querySelectorAll('.js-modal__btn-open');

if (btnModalOpen) {
    btnModalOpen.forEach(function(btn) {
        btn.addEventListener(('click'), function() {
            openModal(this.dataset.openModal);

            if (this.classList.contains('js-modal__btn-mobile-menu')) {
                closeHamburgerMenu();
            }
        });
    });
}

const btnToggles = document.querySelectorAll('.js-toggle-references');

if (btnToggles) {
    btnToggles.forEach(function(toggle) {
        toggle.addEventListener(('click'), function() {
            this.classList.toggle('c-toggle-box__btn--active');
            document.getElementById(this.dataset.toggle).classList.toggle('c-toggle-box--active');
        });
    });
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - Handle trigger modal close
 */
const btnModalClose = document.querySelectorAll('.js-modal__close');

if (btnModalClose) {
    btnModalClose.forEach((btn) => {
        btn.addEventListener(('click'), closeModal);
    });
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - js-form handling
 */

const addressToggle = document.querySelector('.js-form__diff-address');
const addressGroup = document.querySelector('.js-form__diff-address-group');
const btnAddressGroupChange = document.querySelector('.js-form__btn-change');
const btnAddressGroupCancel = document.querySelector('.js-form__btn-cancel');

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - Show the address change group
 */
function showAddressGroup() {
    const addressGroupInputs = addressGroup.querySelectorAll('input');
    addressToggle.checked = true;
    addressGroup.classList.remove('c-form--hidden');
    addressGroupInputs.forEach((input) => {
        input.setAttribute('required', 'required');
    });
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - Hide the address change group
 */
function hideAddressGroup() {
    const addressGroupInputs = addressGroup.querySelectorAll('input');
    addressToggle.checked = false;
    addressGroup.classList.add('c-form--hidden');
    addressGroupInputs.forEach((input) => {
        input.removeAttribute('required');
    });
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - Handle address change toggle (checkbox)
 */
if (addressToggle) {
    addressToggle.addEventListener('change', function() {
        if (this.checked) {
            showAddressGroup();
        } else {
            hideAddressGroup();
        }
    });
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - Handle address change validation
 */
if (btnAddressGroupChange) {
    btnAddressGroupChange.addEventListener('click', () => {
        const addressGroupInputs = addressGroup.querySelectorAll('input');
        const inputArray = [];
        let nrOfInputs = addressGroupInputs.length;
        addressGroupInputs.forEach((input) => {
            if (input.validity.valid) {
                nrOfInputs--;
                input.classList.remove('error');
                inputArray.push(input);
            } else {
                input.classList.add('error');
            }

            if (nrOfInputs === 0) {
                // CHANGE THE ADDRESS HERE
                const personName = inputArray.find((x) => x.id === 's-name').value;
                const personLastName = inputArray.find((x) => x.id === 's-lastname').value;
                const hiddenNameField = document.querySelector('#name');
                hiddenNameField.value = personName + ' ' + personLastName;
                const street = inputArray.find((x) => x.id === 's-workstreet').value;
                const hiddenStreetField = document.querySelector('#street');
                hiddenStreetField.value = street;
                const nr = inputArray.find((x) => x.id === 's-workhousenr').value;
                const hiddenHousNrField = document.querySelector('#housenr');
                hiddenHousNrField.value = nr;
                const zipcode = inputArray.find((x) => x.id === 's-workzipcode').value;
                const hiddenZipCodeField = document.querySelector('#zipcode');
                hiddenZipCodeField.value = zipcode;
                const place = inputArray.find((x) => x.id === 's-workplace').value;
                const hiddenCityField = document.querySelector('#city');
                hiddenCityField.value = place;
                const mobile = inputArray.find((x) => x.id === 's-mobile').value;
                const hiddenMoblieField = document.querySelector('#mobile');
                hiddenMoblieField.value = mobile;
                const email = inputArray.find((x) => x.id === 's-mail').value;
                const hiddenMailField = document.querySelector('#email');
                hiddenMailField.value = email;

                mutateAddressField(personName, personLastName, street, nr, zipcode, place);
                hideAddressGroup();
            }
        });
    });
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - Cancel address change
 */
if (btnAddressGroupCancel) {
    btnAddressGroupCancel.addEventListener('click', hideAddressGroup);
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - Mutate the address field
 *
 * @param {String} personName - name of the person
 * @param {String} personLastName - last name of the person
 * @param {String} street - streetname
 * @param {String} nr - house number
 * @param {String} zipcode - zipcode
 * @param {String} place - place
 */
function mutateAddressField(personName, personLastName, street, nr, zipcode, place) {
    const jsName = document.querySelector('.js-address__name');
    jsName.innerHTML = personName + ' ' + personLastName;
    const jsAddress = document.querySelector('.js-address__street-housenr');
    jsAddress.innerHTML = street + ' ' + nr;
    const jsAddress2 = document.querySelector('.js-address__zipcode-city');
    jsAddress2.innerHTML = zipcode + ' ' + place;
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - Add a product
 */
const btnAddProduct = document.querySelector('.js-form__btn-add-product');
let productCounter = 0;

if (btnAddProduct) {
    btnAddProduct.addEventListener(('click'), function() {
        productCounter++;
        const products = document.querySelector('.js-modal__products');
        const productString = document.querySelector('.js-modal__product');
        let newProduct = productString.outerHTML;
        newProduct = newProduct.replace(/s-prod-select/g, 's-prod-select-' + productCounter);
        newProduct = newProduct.replace(/s-prod-amount/g, 's-prod-amount-' + productCounter);
        newProduct = newProduct.replace(/s-prod-taste/g, 's-prod-taste-' + productCounter);
        products.insertAdjacentHTML('beforeend', newProduct);
    });
}

/**
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @description - Toggle filters
 */
const filterContainer = document.querySelector('.js-filter');
const filterToggleBtn = document.querySelector('.js-filter__toggle');

if (filterContainer) {
    filterToggleBtn.addEventListener('click', () => {
        filterContainer.classList.toggle('c-filter--active');
    });
}

const togglePatientDetails = document.getElementById('orderForPatient');
if (togglePatientDetails) {
    togglePatientDetails.addEventListener('change', function() {
        if (this.checked) {
            document.getElementById('patientDetails').style.display = 'block';
        } else {
            document.getElementById('patientDetails').style.display = 'none';
        }
    });
}

const togglePatientDetailsForm = document.getElementsByName('order_to');
if (togglePatientDetailsForm) {
    for (let i = 0; i < togglePatientDetailsForm.length; i++) {
        togglePatientDetailsForm[i].addEventListener('change', function() {
            if (this.value == 'patient') {
                document.getElementById('patientDetailsForm').style.display = 'block';
            } else {
                document.getElementById('patientDetailsForm').style.display = 'none';
            }
        });
    }
}

const toggleSampleDetails = document.getElementById('samplesForPatient');
if (toggleSampleDetails) {
    toggleSampleDetails.addEventListener('change', function() {
        if (this.checked) {
            document.getElementById('patientDetails').style.display = 'block';
        } else {
            document.getElementById('patientDetails').style.display = 'none';
        }
    });
}

const resetFilters = document.querySelectorAll('.js-clear-filters');
if (resetFilters) {
    for (let i = 0; i < resetFilters.length; i++) {
        resetFilters[i].addEventListener('click', function() {
            const select = document.querySelector('.js-products__group');
            if (select) {
                select.selectedIndex = 0;
            }

            const checkboxes = document.querySelectorAll('.js-filter input[type=checkbox]');
            for (let i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = false;

                if ((i + 1) === checkboxes.length) {
                    const event = new Event('change');
                    checkboxes[i].dispatchEvent(event);
                }
            }
        });
    }
}

const subscribeNews = document.querySelector('.js-news-subscribe');
if (subscribeNews) {
    subscribeNews.addEventListener('click', (event) => {
        event.preventDefault();
        const url = laroute.route('site.user.news.subscribe', {// eslint-disable-line no-undef
            user: subscribeNews.getAttribute('data-user'),
            unsubscribe: 'subscribe'
        });
        const request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                const parent = subscribeNews.parentNode;
                parent.querySelectorAll('p')[0].innerHTML = JSON.parse(this.response);
                subscribeNews.style.display = 'none';
                initUnsubscribeNews();
            }
        };
        request.send();
    });
}

function initUnsubscribeNews() {
    const unsubscribeNews = document.querySelector('.js-news-unsubscribe');
    if (unsubscribeNews) {
        unsubscribeNews.addEventListener('click', (event) => {
            event.preventDefault();
            const url = laroute.route('site.user.news.subscribe', {// eslint-disable-line no-undef
                user: unsubscribeNews.getAttribute('data-user'),
                unsubscribe: 'unsubscribe'
            });
            const request = new XMLHttpRequest();
            request.open('POST', url, true);
            request.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    const parent = subscribeNews.parentNode;
                    parent.querySelectorAll('p')[0].innerHTML = JSON.parse(
                        this.response.replace(/:topic/g, parent.querySelectorAll('p')[0].getAttribute('data-topic'))
                    );
                    subscribeNews.style.display = 'block';
                }
            };
            request.send();
        });
    }
}

const sidePanel = document.querySelector('.js-products__aside');
let panelHeight = 0; // eslint-disable-line no-unused-vars
let containerHeight = 0;

function stickySidePanel() {
    const rect = sidePanel.getBoundingClientRect();
    const productsContain = document.querySelector('.js-products__contain');
    containerHeight = productsContain.offsetHeight;
    panelHeight = sidePanel.offsetHeight;
    const topPos = rect.top + window.scrollY || window.pageYOffset;

    window.addEventListener('scroll', (e) => {
        if (containerHeight !== productsContain.offsetHeight) containerHeight = productsContain.offsetHeight;

        if (window.pageYOffset < (topPos - 50)) {
            sidePanel.classList.remove('c-products__aside--sticky');
            sidePanel.style.left = 'auto';
            sidePanel.classList.add('c-products__aside--top');
            sidePanel.classList.remove('c-products__aside--bottom');
        } else if (window.pageYOffset >= parseInt(window.outerHeight + containerHeight - topPos)) {
            sidePanel.classList.remove('c-products__aside--sticky');
            sidePanel.classList.add('c-products__aside--bottom');
            sidePanel.classList.remove('c-products__aside--top');
        } else {
            sidePanel.classList.add('c-products__aside--sticky');
            sidePanel.style.left = rect.left + 'px';
            sidePanel.classList.add('c-products__aside--top');
            sidePanel.classList.remove('c-products__aside--bottom');
        }
    });
}

if (sidePanel) {
    setTimeout(() => {
        stickySidePanel();
    }, 1000);
}

const btnToggleFilter = document.querySelector('.js-filter__toggle');

if (btnToggleFilter) {
    btnToggleFilter.addEventListener('click', (e) => {
        e.preventDefault();
        if (btnToggleFilter.innerHTML == 'Uitgebreid zoeken <i class="fal fa-plus"></i>') {
            btnToggleFilter.innerHTML = 'Beknopt zoeken <i class="fal fa-minus"></i>';
        } else {
            btnToggleFilter.innerHTML = 'Uitgebreid zoeken <i class="fal fa-plus"></i>';
        }
        const hiddenItems = document.querySelector('.js-filter__holder');
        if (hiddenItems) {
            hiddenItems.classList.toggle('c-product-filter__holder--hidden');
        }
    });
}

const passwordToggle = document.querySelector('.js-create-account');

function checkPasswordToggle() {
    if (passwordToggle.checked) {
        document.querySelector('.js-password').style.display = 'block';
    } else {
        document.querySelector('.js-password').style.display = 'none';
    }
}

if (passwordToggle) {
    checkPasswordToggle();
    passwordToggle.addEventListener('click', (e) => {
        checkPasswordToggle();
    });
}

const functionSelect = document.querySelector('.js-function-select');

function showInterests() {
    const showInterests = document.querySelector('.js-show-interests');
    const interestOption = document.querySelectorAll('.js-interest-option');
    const functionId = functionSelect.value;
    for (let i = 0; i < interestOption.length; ++i) {
        interestOption[i].style.display = 'none';
    }
    if (functionId == 0) {
        showInterests.style.display = 'none';
    } else {
        const jsFunctions = document.querySelectorAll('.js-function-' + functionId);
        if (jsFunctions.length > 0) {
            for (let i = 0; i < jsFunctions.length; ++i) {
                jsFunctions[i].style.display = 'block';
            }
        } else {
            for (let i = 0; i < interestOption.length; ++i) {
                interestOption[i].style.display = 'block';
            }
        }

        showInterests.style.display = 'block';
    }
}

if (functionSelect) {
    showInterests();
    functionSelect.addEventListener('change', (e) => {
        showInterests();
    });
}


/**
 * @description - mobile menu lang switch
 */

const triggerMobileLang = document.querySelector('.js-mobilemenu__lang');

if (triggerMobileLang) {
    triggerMobileLang.addEventListener('click', () => {
        triggerMobileLang.classList.toggle('c-header__lang--active');
    });

    document.addEventListener('click', (e) => {
        const isClickInside = triggerMobileLang.contains(e.target);

        if (!isClickInside) {
            triggerMobileLang.classList.remove('c-header__lang--active');
        }
    });
}
